import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Popup } from 'cat-ecommerce-alloy';
import { Drawer, DrawerBody } from '@cat-ecom/pcc-components';
import CustomHeaderDrawer from '@app/components/common/CustomDrawer/CustomHeaderDrawer/CustomHeaderDrawer';
import {
  DRAWER_DROPDOWN_ORIENTATION,
  DRAWER_DROPDOWN_VERTICAL_MAX_HEIGHT
} from '@app/components/common/DrawerDropdown/DrawerDropdown';
import styles from './styles.modules.scss';

const CoreDepositPopup = ({
  initiator,
  popperOptions = {},
  isDrawerEnabled = false,
  drawerProps = {}
}) => {
  const [t] = useTranslation();

  return (
    <>
      {isDrawerEnabled ? (
        <>
          {initiator}
          <Drawer
            {...drawerProps}
            hideCloseButton
            orientation={DRAWER_DROPDOWN_ORIENTATION.BOTTOM}
            verticalMaxHeight={DRAWER_DROPDOWN_VERTICAL_MAX_HEIGHT.LARGE}
            className={`${styles['core-deposit__drawer']}`}
          >
            <CustomHeaderDrawer
              title={t('CAT_CORE_DEPOSIT_TITLE')}
              onCloseDrawer={drawerProps.closeDrawer}
              headerClassName="text-capitalize"
            />

            <DrawerBody
              className="cat-u-theme-typography-body-sm pt-3"
              data-testid="drawer-body"
            >
              {t('CAT_CORE_UNIT_SELL')}
            </DrawerBody>
          </Drawer>
        </>
      ) : (
        <Popup
          initiator={initiator}
          className={`${styles['core-deposit__popup']}`}
          popperOptions={popperOptions}
          contents={
            <div className={`text-start`}>
              <h3
                className={`text-sans-serif text-xs fw-bold pb-3 mb-0 u-color--ExtraDarkGray`}
              >
                {t('CAT_CORE_DEPOSIT_TITLE')}
              </h3>
              <p className={`m-0 text-xs  u-color--DarkGray `}>
                {t('CAT_CORE_UNIT_SELL')}
              </p>
            </div>
          }
        />
      )}
    </>
  );
};

export default CoreDepositPopup;

CoreDepositPopup.propTypes = {
  initiator: PropTypes.node,
  popperOptions: PropTypes.shape({
    placement: PropTypes.string,
    modifiers: PropTypes.arrayOf(PropTypes.object)
  }),
  isDrawerEnabled: PropTypes.bool,
  drawerProps: PropTypes.shape({
    className: PropTypes.string,
    id: PropTypes.string,
    isActive: PropTypes.bool,
    onBlClose: PropTypes.func,
    hasBackdrop: PropTypes.bool,
    align: PropTypes.string,
    size: PropTypes.string,
    initialActive: PropTypes.func,
    closeDrawer: PropTypes.func
  })
};
